import styles from '../../assets/styles/LandingPage/FeaturesNew.module.scss';
import React from 'react';
import { MimaText, MimaButton } from '../../components';
import PlayStoreIcon from '../../assets/img/playstore.png';
import AppleStoreIcon from '../../assets/img/apple.png';
import {
	MdPayments,
	MdReceiptLong,
} from 'react-icons/md';
import {
	FaWallet,
	FaMoneyBill,
} from 'react-icons/fa';
import { IoIosPeople } from 'react-icons/io';

const FeaturesNew = () => {
	const appleIcon = <img src={AppleStoreIcon} className={styles.btn__icon} alt='APPLE LOGO' />;

	const playIcon = <img src={PlayStoreIcon} className={styles.btn__icon} alt='ANDROID LOGO' />;

	const mimaFeatures = [
		{
			icon: <IoIosPeople />,
			altText: "Global Storefront",
			subtitle: "Sell your products or services to customers worldwide",
			title: "Global Storefront",
			explanation: "Don't let borders limit your sales potential. With our platform, you can sell your products or services to customers worldwide",
		},
		{
			icon: <MdReceiptLong />,
			altText: "Invoicing/Receipt",
			subtitle: "Increased Efficiency",
			title: "Invoicing/Receipt",
			explanation: "Eliminate the need for paper invoices, create and send Invoices/Receipts to your customers easily and receive payments through the invoice.",
		},
		{
			icon: <MdPayments />,
			altText: "Multi currency Transactions",
			subtitle: "Receive Payment in multiple currencies",
			title: "Multi-currency Payment",
			explanation: "Get paid in any currency with ease. Our platform allows you to receive international payments for your products and services directly into your multi-currency wallet, making it simple to manage your global sales.",
		},
		{
			icon: <FaWallet />,
			altText: "Business Account",
			subtitle: "Get a Business Account number",
			title: "Business Account",
			explanation: "Receive payments using your business name and easily manage your finances with our reliable platform. Trust us to handle your payments while you focus on growing your business",
		},
		{
			icon: <FaMoneyBill />,
			altText: "Pay Bills",
			subtitle: "Payment simplified",
			title: "Pay Bills",
			explanation: "A convenient, easy and secure way to manage and pay your bills directly from your mobile device.",
		},
		{
			icon: <MdPayments />,
			altText: "Transactions",
			subtitle: "Track your Income & Expenses",
			title: "Transactions",
			explanation: "Keep track of your daily business incomes and expenses. With this feature you can properly manage your business.",
		},
	]

	return (
		<section className={styles.features} id="features">
			<div className={styles.features__btn}>
				<a href='https://play.google.com/store/apps/details?id=com.mima.mima' style={{ textDecoration: "none" }}>
					<MimaButton
						title="Get app on Android"
						variant="outlined"
						icon={playIcon}
						width={30}

					/>
				</a>

				<a href='https://apps.apple.com/us/app/mima-business/id6444887331' style={{ textDecoration: "none" }}>

					<MimaButton
						title="Get app on iPhone"
						variant="outlined"
						icon={appleIcon}
						width={30}

					/>
				</a>
			</div>
			<MimaText
				variant='h3'
				color='var(--color-dark)'
				align="center"
			>
				Here is how Mima can benefit
				<br />
				your Business....
			</MimaText>
			<div className={styles.features__together}>
				{
					mimaFeatures.map((feat, i) => (
						<div className={styles.features__services} key={i}>
							<span className={styles.features__services__icon}>
								{feat.icon}
							</span>
							<MimaText variant='smallBold' color='var(--color-primary)' mb={1}>{feat.subtitle}</MimaText>
							<MimaText variant='bodyBold' mb={0.5}>{feat.title}</MimaText>
							<MimaText variant='body'> {feat.explanation}
							</MimaText>
						</div>
					))
				}

			</div>
			<div className={styles.features__btn}>
				<a href='https://play.google.com/store/apps/details?id=com.mima.mima' style={{ textDecoration: "none" }}>
					<MimaButton
						title="Get app on Android"
						variant="outlined"
						icon={playIcon}
						width={30}

					/>
				</a>

				<a href='https://apps.apple.com/us/app/mima-business/id6444887331' style={{ textDecoration: "none" }}>

					<MimaButton
						title="Get app on iPhone"
						variant="outlined"
						icon={appleIcon}
						width={30}

					/>
				</a>
			</div>
		</section>
	);
};

export default FeaturesNew;